<template>
  <div class="wrapper team1">
    <div class="breadcrumb">{{$t("main.nav[0].list[1].title")}}</div>
    <div class="container">
      <div class="bg">
        <section class="item1" id="gz1">
          <img src="~assets/main/estate/team/team-gz-01.png"/>
          <div class="des">
            <happy-scroll color="rgba(0,0,0,0.5)" size="5" class="news-scroll" :resize="true" hide-horizontal>
              <!-- 内层盒子——内容区 -->
              <div class="con">
                <div class="title">{{$t("main.des[0].list[12].title")}}</div>
                <div class="text" v-html='$t("main.des[0].list[12].text")'></div>
              </div>
            </happy-scroll>
          </div>
        </section>
        <section class="item2" id="gz2">
          <div class="des">
            <happy-scroll color="rgba(0,0,0,0.5)" size="5" class="news-scroll" :resize="true" hide-horizontal>
              <!-- 内层盒子——内容区 -->
              <div class="con">
                <div class="title">{{$t("main.des[0].list[6].title")}}</div>
                <div class="text" v-html='$t("main.des[0].list[6].text")'></div>
              </div>
            </happy-scroll>
          </div>
          <div class="img"><img src="~assets/main/estate/team/team1-02.jpg"/></div>
        </section>
        <section class="item3" id="gz3">
          <div class="img"><img src="~assets/main/estate/team/team1-03.jpg"/></div>
          <div class="des">
            <happy-scroll color="rgba(0,0,0,0.5)" size="5" class="news-scroll" :resize="true" hide-horizontal>
              <!-- 内层盒子——内容区 -->
              <div class="con">
                <div class="title">{{$t("main.des[0].list[7].title")}}</div>
                <div class="text" v-html='$t("main.des[0].list[7].text")'></div>
              </div>
            </happy-scroll>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'doubleSwiper',
  data () {
    return {
      resize: true
    }
  },
  mounted () {
  },
  beforeMount () {
  },
  computed: {
  },
  created () {
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .des
    width 100%
    margin-top 30px
    height 140px
    .title
      font-size 20px
      font-weight bold
      line-height 32px
    .text
      padding-bottom 30px
    .des
      b
        font-weight bold
  .wrapper
    width 78%
    font-size 15px
    line-height 26px
    .breadcrumb:before
      afterTop()
      width 4px
      height 60%
      top 20%
      background $navBgColor2
    .breadcrumb:after
      afterBottom()
      borderBottom()
      width 100%
      opacity 0.2
    .breadcrumb
      cn()
      font-size 24px
      font-weight bold
      padding 5px 0 5px 20px
      position relative
      margin-bottom 45px
      b
        font-weight normal
        margin-left 10px
    .container
      padding-left 30px
      box-sizing border-box
      .des
        padding 0
      .bg
        background url("~assets/main/estate/team/team1-bg.png")
        fullBg()
        background-position right 0
        .item1
          width 65%
          position relative
          .des
            position absolute
            top 100%
            z-index 2
            width 93%
        .item2
          flexBetween()
          position relative
          align-items flex-end
          margin-top 10%
          .img
            width 41%
          .des
            width 59%
            text-align left
            margin 0
            box-sizing border-box
            padding 0 0 0 5px
        .item3
          position relative
          width 65%
          margin 10% auto 0
          .img
            width 100%
          .des
            width 100%
  @media screen and (max-width: 1366px) {
    .des {
      height 110px!important
    }
    .text {
      padding-bottom 30px
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/main/components/Team1.vue